module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewExperienceletter"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printConfirmationletter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printConfirmationletter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("Experience Letter")])])]), _vm._v(" "), (_vm.seeRecord.user) ? _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.user.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.user) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('td', [_c('b', [_vm._v("\n                          " + _vm._s(_vm.seeRecord.user.name) + " "), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.address) + ",")]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.city) + ",")]), (_vm.seeRecord.state) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.state.name) + " -")]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.pin))]), _c('br')])]), _vm._v(" "), (_vm.seeRecord.branch) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Branch: " + _vm._s(_vm.seeRecord.branch.name) + " "), _c('br'), _vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.currDate)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("TO WHOMSOEVER IT MAY CONCERN")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("This is to certify that Mr/Ms. "), (_vm.seeRecord.user) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.user.name))]) : _vm._e(), _vm._v(" was in employment with us from " + _vm._s(_vm._f("myDate")(_vm.periodStartDate)) + " to " + _vm._s(_vm._f("myDate")(_vm.periodEndDate)) + ".  During this period, he/she was working as a "), (_vm.seeRecord.designation) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.designation.name))]) : _vm._e(), _vm._v(" and was based at "), (_vm.seeRecord.branch) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.branch.address))]) : _vm._e(), _vm._v(". During his/her tenure with us we have found him/her to be sincere and hardworking with high integrity.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("We wish him/her all the best for his/her future endeavors.")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Thanking you")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', [_vm._v("Authorized Signatory")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e()])])])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17c5b303!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/ExperienceLetter.vue
// module id = 765
// module chunks = 0